export default __webpack_public_path__ + "static/media/live.3f70efa2.svg";